import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useAnalyticsTracker } from '../../../../../../tracking/hooks/useAnalyticsTracker';
import { JobAction } from '../../../../../interfaces/job-action';
import { DownloadJobSessionLog } from '../DownloadJobSessionLog';
import { JobsTrackers } from '../../../../../jobs-trackers';
import { JobDetails } from '../../../../../interfaces/job';
import { EntityAction } from '../../../../../../entity-actions/interfaces/entity-actions';

export function useJobActions({
  jobDetails,
  pipelineId,
  onRefreshClick
}: {
  jobDetails: JobDetails;
  pipelineId: number;
  onRefreshClick: VoidFunction;
}) {
  const { actions, jobId } = jobDetails;
  const navigate = useNavigate();
  const { eventTrack } = useAnalyticsTracker();

  const jobActions: EntityAction<JobAction>[] = useMemo(() => {
    return actions.map(action => {
      return {
        ...action,
        ...(action.trackingProps
          ? {
              trackingProps: {
                ...action.trackingProps,
                properties: {
                  jobId
                }
              }
            }
          : {}),
        ...(action.action === JobAction.DOWNLOAD_SESSION_LOGS
          ? {
              CustomAction: (
                <DownloadJobSessionLog pipelineId={pipelineId} actionState={action} jobId={jobId} />
              )
            }
          : {}),
        ...(action.action === JobAction.REFRESH
          ? {
              onClick: onRefreshClick
            }
          : {})
      };
    });
  }, [actions, jobId, pipelineId]);

  const navigateToJobsList = () => {
    eventTrack({
      action: JobsTrackers.JOB_TRACKER_JOB_STATS_NAVIGATE_TO_JOB_LIST_CLICK,
      properties: {
        jobId
      }
    });

    navigate('..', { relative: 'path' });
  };

  return {
    jobActions,
    navigateToJobsList
  };
}
